import { http } from './config'
import authHeader from './auth-header'

export default {
  consultarPessoa: (cpf, segmento = 'corporativo', forceRefresh = false) => {
    return http.post(
      '/lemit/consulta/pessoa',
      {
        cpf,
        segmento,
        forceRefresh,
      },
      {
        headers: {
          ...authHeader(),
          'Content-Type': 'application/json',
        },
      }
    )
  },

  historicoPorCpf: (cpf) => {
    return http.get('/lemit/consulta/pessoa/historico', {
      params: { cpf },
      headers: authHeader(),
    })
  },

  historicoRecente: (limite = 50, somenteMinhas = false) => {
    return http.get('/lemit/consulta/historico', {
      params: { limite, somenteMinhas },
      headers: authHeader(),
    })
  },

  detalheConsulta: (id) => {
    return http.get(`/lemit/consulta/${id}`, {
      headers: authHeader(),
    })
  },

  saldo: () => {
    return http.get('/lemit/saldo', {
      headers: authHeader(),
    })
  },
}
